<template>
  <div class="bg-[#FFFFFF]">
    <div
      class="w-100 bg-[#F8F8F8] border border-2 px-1 py-[1.2rem] rounded-t-xl font-semibold text-black"
    >
      Registrasi Produk
    </div>
    <div class="p-1 border border-2 rounded-b-xl text-black h-[10rem] overflow-auto">
      <div
        class="inline-grid gap-4"
        style="grid-auto-flow: column; grid-template-rows: repeat(2, auto);"
      >
        <div
          v-for="(product, idx) in products"
          :key="idx"
          class="px-[8px] py-[4px] rounded-[8px] bg-[#F8F8F8] d-flex align-center gap-4"
        >
          <div
            class="w-[2.5rem] h-[2.5rem] rounded-circle bg-[#FFFFFF] border grid place-items-center"
          >
            <img
              :src="product.url_image"
              :alt="product.product_name"
              width="20"
              height="20"
            >
          </div>
          <!-- <span class="align-self-center">15 Oktober 2021</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media screen and (min-width: 1280px) {
  .text-truncate {
    max-width: 280px;
  }
}
</style>

<script>
import { IDR } from '@/libs/currency'

export default {
  props: {
    products: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      IDR,
    }
  },
}
</script>
